// extracted by mini-css-extract-plugin
export default {"eachSlideEffect":"Slideshow_eachSlideEffect__n7xYx","sliderImage":"Slideshow_sliderImage__qwkN-"};